import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'
import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './OffersItem.scss'


class OffersItem extends Component {

  static propTypes = {
    size: PropTypes.number.isRequired,
    price: PropTypes.string.isRequired,
    isBest: PropTypes.bool,
    title: PropTypes.string,
    discount: PropTypes.string,
    buttonId: PropTypes.string,
    planName: PropTypes.string,
    isSelected: PropTypes.bool,
    offerTitle: PropTypes.string, // if you need new title, add to messages and us offerTitle
    onChoose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    offerTitle: 'subscription',
    discount: '0',
    isBest: false,
    isCard: false,
    isSelected: false,
  }

  handleButtonClick = () => {
    const { size, price, title, planName, onChoose } = this.props

    onChoose({ size, price, title, planName })
  }

  render() {
    const { price, size, discount, buttonId, offerTitle, isBest, isSelected } = this.props

    const rootClassName = cx(s.container, {
      [s.best]: isBest,
    })

    const bestId = `${buttonId}Best`
    const descriptionId = `${buttonId}Description`

    return (
      <div className={rootClassName} role="group">
        {
          isBest && (
            <div className={s.bestseller} id={bestId} aria-hidden>
              <Text tag="span" message={messages.bestseller} />
            </div>
          )
        }
        <div className={s.content} id={descriptionId} aria-hidden>
          <Text uppercase message={messages.titles[offerTitle]} values={{ size }} />
          <div className={s.price}>${price}</div>
          <Box mt="24">
            <Text message={messages.hint} size="14-24" color="gray" />
          </Box>
          {
            Boolean(parseInt(discount, 10)) && (
              <Box mt="4">
                <Text message={messages.discount} values={{ discount }} color="brand" size="14-24" />
              </Box>
            )
          }
        </div>
        <Box mt="24">
          <Button
            id={buttonId}
            title={messages[isSelected ? 'selectedButtonTitle' : 'buttonTitle']}
            disabled={isSelected}
            size="sm"
            color="brand"
            weight="bold"
            fullWidth
            uppercase
            onClick={this.handleButtonClick}
            ariaDescribedBy={`${bestId} ${descriptionId}`}
          />
        </Box>
      </div>
    )
  }
}


export default OffersItem
